// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2dWri","item":"PaymentsMobile_item__3yfGw","label":"PaymentsMobile_label__UckNs","amount":"PaymentsMobile_amount__1XztM"};